import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router';
// import { uploadImage } from '../../Config/azure-storage-blob.ts';
// import axios from 'axios';
import { ServerPath } from '../../Constant/index.jsx';
import {uploadImage} from '../../Services/r2-storage-blob.js';
import { _axios } from '../../utils/axios.jsx';


const AddImage = () => {
    const [show, setShow] = useState(false);
    const [images, setImages] = useState([]);
    const [imageNames, setImageNames] = useState([]);

    const [uploading, setUploading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFileChange = (e) => {
        const files = e.target.files;
        const names = Array.from(files).map(file => file.name);
        setImages(files);
        setImageNames(names);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setUploading(true);
        try {
            for (let i = 0; i < images.length; i++) {
                const url = await uploadImage(images[i], imageNames[i], 'your-container', 'subfolder');
                setImageUrl(url);

                const newImage = {
                    image: url
                }

                const response = await _axios.post(`${ServerPath}/gallery/create`, newImage);
                console.log(response.data);
            }

            handleClose();

            // Reload the page
            window.location.reload();
        } catch (error) {
            console.error(error);
        } finally {
            setUploading(false);
        }
    };



    return (
        <>
            <Button onClick={handleShow} className='btn btn-primary float-end'>Add Image</Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} className="needs-validation" noValidate>
                        <Row className="g-3">
                            <Form.Group controlId="exampleFormControlTextarea4">
                                <Form.Label>Upload Thumbnail Images</Form.Label>
                                <Form.Control
                                    type="file"
                                    onChange={handleFileChange}
                                    accept="image/*"
                                    multiple
                                    required
                                />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" type='submit' onClick={handleSubmit}>
                        {uploading ? 'Uploading...' : 'Submit'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddImage;
